export const navbarLinks = [
  { label: '首页', href: '/' },
  { label: '漫画分类', href: '/category/all' },
  { label: '漫资讯', href: '/article/latest' },
  { label: '阅读模式', href: '/#reading-modes' },
  { label: '关于我们', href: '/about' },
];

export const categoryList = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'hot-blooded', name: '热血', icon: 'ri-fire-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'sci-fi', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'martial', name: '武侠', icon: 'ri-sword-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const homeHeroSlides = [
  {
    title: '斗破苍穹',
    desc: '天才少年萧炎，在创造了家族空前的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启！',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20martial%20arts%20manhua%20style%20illustration%20with%20a%20young%20warrior%20holding%20a%20flame%20in%20his%20palm%2C%20dramatic%20red%20and%20orange%20energy%20effects%2C%20ancient%20Chinese%20architecture%20in%20background%2C%20epic%20composition%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20anime%20art%20style&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
    link: '/article/doupo-cangqiong',
    badge: '本周最热',
    badgeColor: 'bg-primary-500',
  },
  {
    title: '一人之下',
    desc: '普通大学生张楚岚，因爷爷的坟墓被盗而卷入异人世界的纷争。为追查爷爷死亡真相，他加入了"哪都通"公司，一段波澜壮阔的异能冒险就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20illustration%20featuring%20a%20young%20man%20with%20glowing%20energy%20surrounding%20him%2C%20traditional%20Chinese%20urban%20streets%20with%20lanterns%20at%20night%2C%20mystical%20atmosphere%2C%20action%20pose%2C%20vibrant%20comic%20art%20style%20with%20dramatic%20lighting&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
    link: '/article/yirenzhixia',
    badge: '新番推荐',
    badgeColor: 'bg-accent-500',
  },
  {
    title: '狐妖小红娘',
    desc: '根据古典小说记载，世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。人死了，妖活着。人会投胎转世，但投胎以后，不记得上辈子的爱。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20manhua%20art%2C%20beautiful%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20in%20traditional%20red%20dress%2C%20cherry%20blossom%20petals%20floating%2C%20ancient%20Chinese%20temple%20background%2C%20soft%20pink%20and%20golden%20lighting%2C%20ethereal%20atmosphere&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
    link: '/article/huyao',
    badge: '经典必读',
    badgeColor: 'bg-primary-600',
  },
];

export const trendingComics = [
  {
    id: 1,
    title: '斗破苍穹',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%2C%20young%20martial%20artist%20with%20flame%20powers%2C%20dynamic%20action%20pose%2C%20red%20and%20gold%20color%20scheme%2C%20simple%20muted%20background%2C%20clean%20composition&width=400&height=560&seq=trending-01&orientation=portrait',
    author: '天蚕土豆',
    category: '热血',
    rating: 9.5,
    views: '1.2亿',
    updateTo: '第456话',
    isNew: false,
    isHot: true,
  },
  {
    id: 2,
    title: '一人之下',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20cover%2C%20young%20protagonist%20with%20glowing%20eyes%2C%20urban%20supernatural%20theme%2C%20dark%20blue%20and%20purple%20tones%2C%20simple%20background%2C%20clean%20art%20style&width=400&height=560&seq=trending-02&orientation=portrait',
    author: '米二',
    category: '奇幻',
    rating: 9.7,
    views: '8900万',
    updateTo: '第623话',
    isNew: false,
    isHot: true,
  },
  {
    id: 3,
    title: '狐妖小红娘',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20fantasy%20manhua%20cover%2C%20fox%20girl%20with%20red%20dress%2C%20cherry%20blossom%20theme%2C%20pink%20and%20soft%20color%20palette%2C%20simple%20elegant%20background&width=400&height=560&seq=trending-03&orientation=portrait',
    author: '小新',
    category: '恋爱',
    rating: 9.6,
    views: '1.5亿',
    updateTo: '第512话',
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    title: '全职高手',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manhua%20cover%2C%20cool%20gamer%20character%20holding%20a%20mouse%2C%20digital%20glitch%20effects%2C%20dark%20blue%20neon%20color%20scheme%2C%20simple%20background%2C%20clean%20minimal%20style&width=400&height=560&seq=trending-04&orientation=portrait',
    author: '蝴蝶蓝',
    category: '科幻',
    rating: 9.4,
    views: '9800万',
    updateTo: '第389话',
    isNew: false,
    isHot: false,
  },
  {
    id: 5,
    title: '镖人',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%2C%20desert%20warrior%20with%20sword%2C%20rugged%20realistic%20ink%20wash%20art%20style%2C%20warm%20earth%20tones%2C%20simple%20background%2C%20dramatic%20composition&width=400&height=560&seq=trending-05&orientation=portrait',
    author: '许先哲',
    category: '武侠',
    rating: 9.8,
    views: '6200万',
    updateTo: '第198话',
    isNew: false,
    isHot: true,
  },
  {
    id: 6,
    title: '星海镖师',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20cover%2C%20space%20bounty%20hunter%20character%2C%20futuristic%20armor%2C%20starfield%20background%2C%20cool%20cyan%20and%20silver%20color%20scheme%2C%20simple%20clean%20composition&width=400&height=560&seq=trending-06&orientation=portrait',
    author: '颜开',
    category: '科幻',
    rating: 9.3,
    views: '4500万',
    updateTo: '第267话',
    isNew: true,
    isHot: false,
  },
  {
    id: 7,
    title: '镇魂街',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20manhua%20cover%2C%20guardian%20spirit%20warrior%2C%20ancient%20and%20modern%20fusion%20style%2C%20dark%20atmospheric%20tone%2C%20simple%20background%2C%20powerful%20composition&width=400&height=560&seq=trending-07&orientation=portrait',
    author: '许辰',
    category: '热血',
    rating: 9.5,
    views: '7800万',
    updateTo: '第345话',
    isNew: false,
    isHot: false,
  },
  {
    id: 8,
    title: '大理寺日志',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20comedy%20manhua%20cover%2C%20cat%20official%20in%20ancient%20Chinese%20court%20robe%2C%20humorous%20expression%2C%20warm%20historical%20color%20palette%2C%20simple%20clean%20background&width=400&height=560&seq=trending-08&orientation=portrait',
    author: 'RC',
    category: '搞笑',
    rating: 9.6,
    views: '5600万',
    updateTo: '第234话',
    isNew: true,
    isHot: false,
  },
];

export const latestUpdates = [
  { id: 1, title: '斗破苍穹', chapter: '第456话 炼药大会（下）', time: '3分钟前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20thumbnail%2C%20young%20warrior%20with%20flame%20energy%2C%20dramatic%20red%20lighting%2C%20simple%20clean%20background%2C%20compact%20portrait%20format&width=200&height=280&seq=latest-01&orientation=portrait' },
  { id: 2, title: '一人之下', chapter: '第623话 八奇技之谜', time: '15分钟前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20thumbnail%2C%20character%20with%20energy%20aura%2C%20mystical%20blue%20light%2C%20simple%20background%2C%20compact%20portrait%20format&width=200&height=280&seq=latest-02&orientation=portrait' },
  { id: 3, title: '狐妖小红娘', chapter: '第512话 前世之约', time: '28分钟前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20thumbnail%2C%20beautiful%20girl%20with%20fox%20ears%2C%20pink%20cherry%20blossom%20theme%2C%20simple%20soft%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-03&orientation=portrait' },
  { id: 4, title: '镇魂街', chapter: '第345话 守护灵觉醒', time: '42分钟前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20action%20manhua%20thumbnail%2C%20armored%20spirit%20guardian%2C%20dark%20atmospheric%20tone%2C%20simple%20background%2C%20compact%20portrait%20format&width=200&height=280&seq=latest-04&orientation=portrait' },
  { id: 5, title: '全职高手', chapter: '第389话 总决赛之夜', time: '1小时前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20manhua%20thumbnail%2C%20cool%20esports%20character%2C%20digital%20neon%20effects%2C%20simple%20dark%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-05&orientation=portrait' },
  { id: 6, title: '镖人', chapter: '第198话 大漠孤烟', time: '1小时前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20manhua%20thumbnail%2C%20desert%20warrior%20silhouette%2C%20warm%20earth%20tone%2C%20simple%20rugged%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-06&orientation=portrait' },
  { id: 7, title: '大理寺日志', chapter: '第234话 猫爷探案', time: '2小时前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20historical%20manhua%20thumbnail%2C%20cat%20official%20character%2C%20funny%20expression%2C%20warm%20ancient%20tone%2C%20simple%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-07&orientation=portrait' },
  { id: 8, title: '星海镖师', chapter: '第267话 星际猎手', time: '3小时前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20thumbnail%2C%20space%20bounty%20hunter%2C%20futuristic%20suit%2C%20starfield%2C%20simple%20dark%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-08&orientation=portrait' },
  { id: 9, title: '妖神记', chapter: '第156话 妖族秘术', time: '4小时前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20thumbnail%2C%20demon%20spirit%20character%2C%20purple%20mystical%20energy%2C%20simple%20dark%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-09&orientation=portrait' },
  { id: 10, title: '仙王的日常生活', chapter: '第312话 校园乱斗', time: '5小时前', cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20school%20life%20manhua%20thumbnail%2C%20student%20with%20magical%20powers%2C%20humorous%20scene%2C%20bright%20simple%20background%2C%20compact%20portrait&width=200&height=280&seq=latest-10&orientation=portrait' },
];

export const readingModes = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式漫画阅读',
    desc: '像刷短视频一样流畅地阅读漫画，手指下滑即可无缝切换话数，告别频繁点击翻页的烦恼。支持自动预加载，网速再慢也不卡顿，让你沉浸在连续的视觉叙事中。',
    features: ['无限下拉加载', '智能预缓存', '话数无缝衔接', '自适应滚动速度'],
  },
  {
    icon: 'ri-book-open-line',
    title: '翻页漫画',
    desc: '还原纸质漫画的翻页体验，左右滑动即可优雅翻页。支持单页和双页两种显示模式，长条漫画自动分页，给你最接近实体书的阅读感受。',
    features: ['左右翻页动画', '单页/双页切换', '长条自动分页', '书签记忆功能'],
  },
  {
    icon: 'ri-fullscreen-line',
    title: '漫画全屏观看',
    desc: '一键进入全屏模式，隐藏所有界面元素，让你的屏幕只剩下纯粹的漫画画面。配合高分辨率图片加载技术，每一格细节都清晰可见。',
    features: ['沉浸式全屏', '高清图片加载', '自动屏幕亮度', '手势快捷操作'],
  },
  {
    icon: 'ri-shield-check-line',
    title: '无弹窗漫画',
    desc: '彻底告别烦人的弹窗广告和恶意跳转，纯粹干净的阅读环境。我们承诺永远不在阅读页面插入任何形式的广告弹窗，让你安心追漫。',
    features: ['零弹窗干扰', '无恶意跳转', '纯净阅读体验', '安全浏览环境'],
  },
];

export const homeArticles = [
  {
    id: 1,
    slug: 'doupo-cangqiong',
    title: '斗破苍穹：从废材到巅峰的热血逆袭之路',
    excerpt: '《斗破苍穹》作为国漫扛鼎之作，讲述了萧炎从天才陨落到重登巅峰的励志故事。本文深度解析这部现象级作品为什么能俘获亿万读者的心。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20scene%2C%20young%20warrior%20training%20in%20mountain%20temple%2C%20flame%20energy%20surrounding%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20warm%20golden%20tone&width=800&height=450&seq=article-home-01&orientation=landscape',
    category: '作品解读',
    date: '2026-08-01',
    readTime: '8分钟',
  },
  {
    id: 2,
    slug: 'yirenzhixia',
    title: '一人之下：异人世界的宏大世界观构建',
    excerpt: '从道家内丹到八奇技，《一人之下》构建了一个融合中国传统文化的异能世界。本文带你深入探索这个引人入胜的异人宇宙。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20scene%2C%20mystical%20energy%20battle%20in%20urban%20setting%2C%20traditional%20elements%20mixed%20with%20modern%2C%20cool%20blue%20lighting%2C%20dramatic%20composition&width=800&height=450&seq=article-home-02&orientation=landscape',
    category: '世界观分析',
    date: '2026-07-28',
    readTime: '10分钟',
  },
  {
    id: 3,
    slug: 'manhua-trend-2026',
    title: '2026年国漫趋势：这些新番你不能错过',
    excerpt: '国漫市场持续火爆，2026年又有哪些值得期待的新作？从热血战斗到悬疑推理，我们为你整理了今年最值得关注的作品清单。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20mosaic%20of%20Chinese%20manhua%20characters%20collage%2C%20various%20styles%20and%20genres%2C%20vibrant%20colorful%20composition%2C%20animated%20style%2C%20modern%20design%2C%20bright%20and%20energetic&width=800&height=450&seq=article-home-03&orientation=landscape',
    category: '行业资讯',
    date: '2026-07-25',
    readTime: '6分钟',
  },
];

export const siteStats = [
  { value: '5000+', label: '海量漫画资源' },
  { value: '99.9%', label: '无广告阅读率' },
  { value: '800万+', label: '忠实读者用户' },
  { value: '每日更新', label: '稳定更新频率' },
];